export function getAll() {
  var items = [
    {
      value: 0,
      name: "All",
      text: "全部",
    },
    {
      value: 1,
      name: "GreaterThanZero",
      text: "大於0",
    },
    {
      value: 2,
      name: "LessThanZero",
      text: "小於0",
    },
    {
      value: 3,
      name: "Zero",
      text: "0",
    },
    {
      value: 4,
      name: "GreaterAndEqualZero",
      text: "大於等於0",
    },
  ];
  return items;
}

export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
